/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, inject } from '@angular/core';
import { GmcErrorsRegistry } from './gmc-errors-registry';

@Directive({
  selector: 'ng-template[gmcError]',
  standalone: true,
})
export class GmcErrorDirective implements OnChanges {
  private registry = inject(GmcErrorsRegistry);
  private templateRef: TemplateRef<any> = inject(TemplateRef);

  @Input() default = false;
  @Input() gmcError?: string;

  ngOnChanges(changes: SimpleChanges) {
    if ('gmcError' in changes) {
      if (this.gmcError && this.templateRef) {
        this.registry.addErrorTemplate(this.gmcError, this.templateRef, this.default);
      }
    }
  }
}
